import { API } from "aws-amplify";
import { API_NAME } from "../common/constants";

export const postNotificationDocsNotifyBulk = async (
  yearMonth: string,
  paymentCode: string,
  subject: string,
  body: string
) => {
  const path = `/notification-docs-notify?year_month=${yearMonth}&payment_code=${encodeURIComponent(
    paymentCode
  )}`;
  const params = { body: { subject, body } };
  let result: any;
  await API.post(API_NAME, path, params)
    .then((response) => {
      result = response;
    })
    .catch((e) => {
      console.error(e);
      result = e.response.data;
    });
  return result;
};
